(function () {
    if (window._imageTextFadeInInit) return;
    window._imageTextFadeInInit = true;

    function init() {
        var elements = document.querySelectorAll('.image-text-section');
        if (!elements.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.05 });

        elements.forEach(function (el) {
            observer.observe(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

(function () {
    if (window._personinfoFadeInInit) return;
    window._personinfoFadeInInit = true;

    function init() {
        var elements = document.querySelectorAll('.personinfo-item');
        if (!elements.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.05 });

        elements.forEach(function (el, index) {
            el.style.transitionDelay = (index % 3) * 0.15 + 's';
            observer.observe(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

(function () {
    if (window._factsFadeInInit) return;
    window._factsFadeInInit = true;

    function init() {
        var elements = document.querySelectorAll('.fact-element');
        if (!elements.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.05 });

        elements.forEach(function (el, index) {
            el.style.transitionDelay = (index % 4) * 0.15 + 's';
            observer.observe(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

(function () {
    if (window._contactsliderFadeInInit) return;
    window._contactsliderFadeInInit = true;

    function init() {
        var elements = document.querySelectorAll('.contactslider-element');
        if (!elements.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.05 });

        elements.forEach(function (el, index) {
            el.style.transitionDelay = (index % 4) * 0.15 + 's';
            observer.observe(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();